var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import SettingsSvg from './settings-01.icon.svg';
export const SettingsIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: SettingsSvg }));
_react_refresh_temp_1 = SettingsIcon;
$RefreshReg$(_react_refresh_temp_1, "SettingsIcon");
